import React from "react";
import "./AboutUs.css";


const AboutUs = () => {
    const stats = [
        { id: 1, value: "350", label: "Companies Valued", bgColor: "#003366" },
        { id: 2, value: "$100m", label: "Funding Secured", bgColor: "#ffffff" },
        { id: 3, value: "325", label: "Project Done", bgColor: "#ffffff" },
    ];

    return (
        <div className="About-main-container" style={{ position: "relative" }}>
            <div className="highlight-card highlight-card-about" />
            <div className="about-us-container Onlybottom-border m12" >
                {/* <div className="HowClybourneWorks-card-wrapper"> */}

                <div className="about-us-text">
                    <h5>About Us</h5>
                    <h2>
                        Our Story:
                    </h2>
                    <h1 className="mb">Redefining Business Valuation</h1>
                    <p>
                        At Clybourne, we’re on a mission to make accurate valuations simple,
                        insightful, and accessible to businesses worldwide.
                    </p>
                </div>
                <div className="stats-section">
                    <div className="stats-container">
                        {stats.map((stat, index) => (
                            <div
                                key={stat.id}
                                className="stat-card"
                                style={{ backgroundColor: stat.bgColor }}
                            >
                                <h3 className={index === 0 ? "white-text" : "black-text"}>
                                    {stat.value}
                                </h3>
                                <p className={index === 0 ? "white-text" : "gray-text"}>
                                    {stat.label}
                                </p>
                            </div>
                        ))}
                        {/* <div className="highlight-card highlight-card-about"></div> */}
                    </div>
                </div>
                {/* </div> */}
            </div>
        </div>
    );
};

export default AboutUs;
